module.exports = __webpack_public_path__ + "static/media/lentil.b395dd28.jpg";